<style scoped>
    .logistic_echart>div{
        height: 300px;
    }
    .logistic_echart .width-33per{
        width:33%;
    }
</style>
<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-right">
               <div class="pull-right">
                    <Form inline>
                        <Button type="primary" @click="update(true)" icon="ios-search">查询</Button>
                        <Button @click="resetdata" icon='md-refresh'>重置</Button>
                    </Form>
                </div>
                <Form :label-width="100" inline>
                   <FormItem label='活动开始时间' style="width:330px;">
                          <DatePicker type="daterange"
                                     placement="bottom-end"
                                     placeholder="Select date"
                                     style="width:220px;"
                                     :value="getshipdate"
                                     @on-change="handleChange"
                         ></DatePicker>
                    </FormItem>
                     <FormItem label='活动结束时间' style="width:330px;">
                        <DatePicker type="daterange"
                                    placement="bottom-end"
                                    placeholder="Select date"
                                    style="width:220px;"
                                    @on-change="handleChangeCreated"
                        ></DatePicker>
                   </FormItem>
                     <FormItem label='项目'>
                          <Select v-model="formData.EQ_lineId" filterable clearable>
                              <Option v-for="item in getNewDifferentAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                     </FormItem>
                      <FormItem label='负责人'>
                         <Input clearable v-model.trim="formData.CN_updatedName" />
                     </FormItem>
                      <FormItem label='推广渠道'>
                         <Select v-model="formData.EQ_promotionAccount" filterable clearable>
                              <Option v-for="item in accountType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                     </FormItem>
                </Form>
            </div>

        </article>
        <transition>
            <Form inline class="search-other">
                <Button type="info"  class="margin-right-5" @click="handleChangeTime(1)">最近一周</Button>
                <Button type="default" class="margin-right-5 dark-primary" @click="handleChangeTime(2)">最近一月</Button>
                <Button type="success" class="margin-right-5" @click="handleChangeTime(3)">最近一季度</Button>
                <Button type="warning" class="margin-right-5" @click="handleChangeTime(4)">最近一年</Button>
            </Form>
        </transition>
        <transition>
             <div class="clearfix margin-top-20">
                <Row :gutter="15" type="flex" justify="center">
                    <Col span="7">
                        <div class="bg-confirm color-white">
                            <div class="litTitle">活动总计</div>
                            <div class="padding-10 height-90">
                                <div class="font-30">{{listData.sum}}</div>
                            </div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="bg-success color-white">
                            <div class="litTitle">已提交</div>
                            <div class="padding-10 height-90">
                                <div class="font-30">{{listData.submit}}</div>
                            </div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="bg-warning color-white">
                            <div class="litTitle">处理中</div>
                            <div class="padding-10 height-90">
                                <div class="font-30">{{listData.processing}}</div>
                            </div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="bg-info color-white">
                            <div class="litTitle">已完成</div>
                            <div class="padding-10 height-90">
                                <div class="font-30">{{listData.success}}</div>
                            </div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="bg-error color-white">
                            <div class="litTitle">已驳回</div>
                            <div class="padding-10 height-90">
                                <div class="font-30">{{listData.reject}}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </transition>
        <transition>
            <div class="clearfix logistic_echart margin-top-20">
                <div class="echart_bar width-100per pull-left"></div>
                <div class="echart_line1 width-50per pull-left"></div>
                <div class="echart_line2 width-50per pull-left"></div>
            </div>
        </transition>
        <transition>
            <div>
                <Form :label-width="100" inline>
                     <FormItem label="活动开始时间" style="width:330px;">
                        <DatePicker type="daterange"
                                    placement="bottom-end"
                                    placeholder="Select date"
                                    style="width:220px;"
                                    ref="amazonTime"
                                    @on-change="handleChangeByManage"
                        ></DatePicker>
                    </FormItem>
                   <vButton theme="primary" @click="searchTable">查询</vButton>
                </Form>

                <vTable
                class="margin-left-20 margin-right-20"
				:columns="columns"
				:data="datalist"
				size="small"
				ref="tablequery"
				border
                ></vTable>
            </div>
        </transition>
        <vLoading fix :loading="loading" transfer></vLoading>
    </div>
</template>

<script>

import { mapState,mapGetters} from "vuex";
import {
    HttpGetPromotionReport,
    HttpGetWork,
    HttpGetLineName,
    HttpGetPersonTable,
} from "@/service/products/promotion";

    export default {
        data() {
            return {
                loading:false,
               accountType: [
           {
                                value: '站外deal free',
                                label: '站外deal free'
                            },
                            {
                                value: '站外deal pay',
                                label: '站外deal pay'
                            },
                            {
                                value: '站外Facebook Giveaway',
                                label: '站外Facebook Giveaway'
                            },
                            {
                                value: '站外FB DEAL GROUP',
                                label: '站外FB DEAL GROUP'
                            },
                            {
                                value: '红人营销',
                                label: '红人营销'
                            },
                            {
                                value: 'AMZ AFFILIATE',
                                label: 'AMZ AFFILIATE'
                            },
                            {
                                value: '站外Coupon site',
                                label: '站外Coupon site'
                            },
                            {
                                value: '站内LD',
                                label: '站内LD'
                            },
                            {
                                value: '站内BD',
                                label: '站内BD'
                            },
                            {
                                value: '站内7-Day deal',
                                label: '站内7-Day deal'
                            },
                            {
                                value: '站内webstore',
                                label: '站内webstore'
                            },
                            {
                                value: '站内social promotion',
                                label: '站内social promotion'
                            },
                            ],
                formData:{
                    EQ_lineId:'',
                    CN_updatedName:'',
                    EQ_promotionAccount:'',
                    EQ_status:'',
                    BT_beginTime:'',
                    BT_endTime:'',
                },
                getshipdate:[],
                listData:{
                    sum:0,
                    submit:0,
                    processing:0,
                    success:0,
                    reject:0,
                },
                datalist:[],
                startBefore:'',
                startAfter:'',
                endBefore:'',
                endAfter:'',
                startTime:'',
                endTime:'',
            };
        },
        created() {
            this.getshipdate = []
            this.update();
        },
        computed: {
            ...mapGetters('diction',['getNewDifferentAllProductList']),
            columns(){
                return [{
                    title: '姓名',
                    key: 'name',
                }, {
                    title: '草稿',
                    key: '0',
                }, {
                    title: '已提交',
                    key: '1',
                },{
                    title: '处理中',
                    key: '2',
                },{
                    title: '已完成',
                    key: '3',
                },{
                    title: '已驳回',
                    key: '4',
                },{
                    title: '总计',
                    key: '5',
                },]
            }
    },
    methods: {
       handleChangeByManage(data){
    //    console.log(data[0])
    //    console.log(data[1])
                this.startTime = data[0] + ' 00:00:00'
                this.endTime = data[1] + ' 00:00:00'
            },
        update(type,parms){
            this.loading=true
            const formdata = {search: { ...this.formData, }};
            let arrprop = []
            HttpGetPromotionReport(formdata).then(res=>{
                for(var item in res.data){
                    if(res.data.hasOwnProperty(item)){
                        if(item == '总计'){
                            this.listData.sum = res.data[item]
                        }
                        if(item == '已提交'){
                            this.listData.submit = res.data[item]
                        }
                        if(item == '处理中'){
                        this.listData.processing = res.data[item]
                        }
                        if(item == '已完成'){
                            this.listData.success = res.data[item]
                        }
                        if(item == '已驳回'){
                            this.listData.reject = res.data[item]
                        }
                    }
                    if(item == '总计') continue
                    else arrprop.push({value:res.data[item],name:item})
                }
                // console.log(arrprop)
                //  各个图形的加载
                this.echartStatuPie(arrprop);
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            // 工作进度分布
            HttpGetWork(formdata).then(res=>{
                // console.log(res)
                let formdata = res.data
                let workStatus=[],workjson={},arrIndex=0,personname=[],datalist=[];

                for(var key1 in formdata){
                    workStatus.push(key1)
                    formdata[key1].map(item=>{
                        let keyvalue = item.updatedName === "" ? '未分配': item.updatedName
                        if(!workjson[keyvalue]){
                            workjson[keyvalue] = Array(Object.keys(formdata).length).fill(0); //默认给数组内容赋值0
                        }
                        if(!workjson[keyvalue][arrIndex]){
                            workjson[keyvalue][arrIndex] = 0
                        }
                        workjson[keyvalue][arrIndex]++
                    })
                    arrIndex++;
                }

                for(let key in workjson){
                    personname.push(key)
                    let datajson = {
                        name:key,
                        type:'bar',
                        stack:'总量',
                        label:{
                            show: true,
                            position: 'insideRight'
                        },
                        data:workjson[key]
                    }
                    datalist.push(datajson)
                }

                this.echartNameBar(personname,workStatus,datalist)
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            let linedata={
                startBefore:this.startBefore,
                startAfter:this.startAfter,
                endBefore:this.endBefore,
                endAfter:this.endAfter,
                lineId:this.formData.EQ_lineId,
                name:this.formData.CN_updatedName,
                account:this.formData.EQ_promotionAccount
            }
            // 项目列表匹配
            HttpGetLineName(linedata).then(res=>{
                // console.log(res)
                let result = [];

                for(let i in res.data){
                    result.push({name:i,value:res.data[i]})
                }
                result = result.sort((a,b)=>{
                    return Number(b.value)-Number(a.value);
                });
                // 取出前十位展示
                let lineList = result.slice(0,10)
                let linename=[],namedata=[];
                lineList.map(item=>{
                    item.name = this.findRenderLabel(this.getNewDifferentAllProductList, item.name)
                    linename.push(item.name);
                    namedata.push(item.value);
                })
                this.echartLineBar(linename,namedata);
                this.loading=false

            },err=>{
                this.loading=false
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            this.searchTable()
        },
        resetdata(){
            this.getshipdate = []
            this.formData = []
            let arrprop = []
           HttpGetPromotionReport(this.formData).then(res=>{
               for(var item in res.data){
                    if(res.data.hasOwnProperty(item)){
                        if(item == '总计'){
                            this.listData.sum = res.data[item]
                        }
                        if(item == '已提交'){
                            this.listData.submit = res.data[item]
                        }
                        if(item == '处理中'){
                            this.listData.processing = res.data[item]
                        }
                        if(item == '已完成'){
                            this.listData.success = res.data[item]
                        }
                        if(item == '已驳回'){
                            this.listData.reject = res.data[item]
                        }
                    }
                    if(item == '总计') continue
                    else arrprop.push({value:res.data[item],name:item})
               }
               this.echartStatuPie(arrprop);
               this.loading=false
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        echartNameBar(personname,workStatus,datalist){
            const echart = Echarts.init(this.$el.querySelector(".echart_bar"));
            // 绘制图表
            echart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                color:['#2db7f5','#f90','#808695','#19be6b','#ed3f14'],
                legend: {
                    data: personname
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    data: workStatus
                },
                series: datalist
            });
        },
        echartLineBar(linename,namedata){
            const echart = Echarts.init(this.$el.querySelector(".echart_line1"));
            echart.setOption({
                title: {
                    text: "项目分布",
                    left: "center"
                },
                xAxis: {
                    type: 'category',
                    data: linename,
                    axisLabel: {
                        interval:0,
                        rotate:18
                    },
                },
                color:['#ed3f14'],
                yAxis: {
                    type: 'value'
                },

                series: [{
                    data: namedata,
                    type: 'bar'
                }]
            })
        },
        echartStatuPie(dataprop){
            // console.log(dataprop,'dadada')
            const echart = Echarts.init(this.$el.querySelector(".echart_line2"));
            echart.setOption({
                title: {
                    text: "状态分布",
                    left: "center"
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    top:20,
                    "itemGap": 15,
                    'itemWidth':10,
                    formatter: function(name) {
                        var index = 0;
                        dataprop.forEach(function(item,i){
                            if(item.name == name){
                                index = i;
                            }
                        });
                        return name + "  " + dataprop[index].value;
                    }
                },
                color:['#2db7f5','#f90','#808695','#19be6b','#ed3f14'],
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "50%",
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                        },
                        startAngle:90,  //开始 的旋转角度

                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
                                    position: 'inner'

                                },
                                labelLine: {
                                    show: false,
                                }
                            }
                        },
                        data: dataprop,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });
        },
        handleChange(date){
            this.formData.BT_beginTime = date[0] + " ~ " + date[1]
            this.startBefore = date[0];
            this.startAfter = date[1];

        },
        handleChangeCreated(date){
            this.formData.BT_endTime = date[0] + " ~ " + date[1]
            this.endBefore = date[0]
            this.endAfter = date[1]
        },

        handleChangeTime(type){
            var date = new Date();
            if(type == 1){
                    var list = this.getDateRange(date, 7, true);
            }
            if(type == 2){
                    var list = this.getDateRange(date, 30, true);
            }
            if(type == 3){
                    var list = this.getDateRange(date, 90, true);
            }
            if(type == 4){
            var list = this.getDateRange(date, 365, true);
            }
            this.formData.BT_beginTime =  list[0] + " ~ " + list[1]
            this.update()
        },
        searchTable(){
            // table列表的请求
            HttpGetPersonTable({
                startTime:this.startTime,
                endTime:this.endTime
            }).then(res=>{
                // console.log(res)
                this.datalist = res.data
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        getDateRange(dateNow,intervalDays,bolPastTime){
                let oneDayTime = 24 * 60 * 60 * 1000;
                let list = [];
                let lastDay;

                if(bolPastTime == true){
                    lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
                    list.push(this.formateDate(lastDay));
                    list.push(this.formateDate(dateNow));
                }else{
                    lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
                    list.push(this.formateDate(dateNow));
                    list.push(this.formateDate(lastDay));
                }
                return list;
            },
        formateDate(time){
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let day = time.getDate()

            if (month < 10) {
                month = '0' + month
            }

            if (day < 10) {
                day = '0' + day
            }
            return year + '-' + month + '-' + day + ''
        },

    },
    };
</script>
